"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPER_PROPERTIES_KEY = exports.IntegrationNames = exports.PLUGINS_FOLDER_PATH = exports.INTEGRATIONS_FOLDER_PATH = exports.BuildType = exports.RUDDERSTACK_SDK_VERSION = exports.DEFAULT_SDK_VERSION = void 0;
// Rudderstack loads latest released version destinations bundle for SDK v3
exports.DEFAULT_SDK_VERSION = 'v3';
// the same as @rudderstack/analytics-js package version
exports.RUDDERSTACK_SDK_VERSION = '3.11.13';
// Depending on the browser, the SDK loads either the legacy
// or modern JavaScript SDK bundle. The legacy bundle is built
// for ES5 while the modern bundle (with Module Federation) is
// built for ES6
var BuildType;
(function (BuildType) {
    BuildType["Legacy"] = "legacy";
    BuildType["Modern"] = "modern";
})(BuildType || (exports.BuildType = BuildType = {}));
exports.INTEGRATIONS_FOLDER_PATH = 'js-integrations';
exports.PLUGINS_FOLDER_PATH = 'plugins';
// The destination name in the "integrations" object should match
// the name exactly as displayed in the RudderStack dashboard (UI config).
// It should not be the name that you assigned to the destination
// while setting it up in RudderStack.
var IntegrationNames;
(function (IntegrationNames) {
    IntegrationNames["BigQuery"] = "BigQuery";
    IntegrationNames["BingAds"] = "Bing Ads";
    IntegrationNames["FacebookConversions"] = "Facebook Conversions";
    IntegrationNames["FacebookPixel"] = "Facebook Pixel";
    IntegrationNames["GoogleAds"] = "Google Ads";
    IntegrationNames["GoogleAnalytics4"] = "Google Analytics 4 (GA4)";
    IntegrationNames["GoogleCloudStorage"] = "Google Cloud Storage";
    IntegrationNames["GoogleCloudStorageDatalake"] = "Google Cloud Storage Datalake";
    IntegrationNames["Hotjar"] = "Hotjar";
    IntegrationNames["HubSpot"] = "HubSpot";
    IntegrationNames["Intercom"] = "Intercom";
    IntegrationNames["LinkedIn"] = "Linkedin Insight Tag";
    IntegrationNames["Mixpanel"] = "Mixpanel";
    IntegrationNames["PinterestTag"] = "Pinterest Tag";
    IntegrationNames["PostAffiliatePro"] = "Post Affiliate Pro";
    IntegrationNames["RedditPixel"] = "Reddit Pixel";
    IntegrationNames["Rockerbox"] = "Rockerbox";
    IntegrationNames["Slack"] = "Slack";
    IntegrationNames["SnapPixel"] = "Snap Pixel";
    IntegrationNames["Snowflake"] = "Snowflake";
    IntegrationNames["TikTokAds"] = "TikTok Ads";
})(IntegrationNames || (exports.IntegrationNames = IntegrationNames = {}));
exports.SUPER_PROPERTIES_KEY = '_hbf_a_sp';
//# sourceMappingURL=constants.js.map